import { CalculatorResponseDTO, FinancingMangoShow } from './../../model/requests-model';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  FINANCE,
  FORM_MG,
  PENDIENTES_DE_DATOS,
  REQUEST_DATA_MG,
  REQUEST_MODE_VIEW,
} from '@app/@core/constants/requests.constants';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { CommonDataDTO } from '@app/requests/model/combos-model';

@Component({
  selector: 'scf-request-finance-mg',
  templateUrl: './request-finance-mg.component.html',
  styleUrls: ['./request-finance-mg.component.scss'],
})
export class RequestFinanceMgComponent implements OnInit, OnChanges {
  //Needs to be the same as properties of object used
  displayedColumns: string[] = ['percentageDiscount', 'percentageWelcome', 'netPursacheAmount'];
  dataSource = new MatTableDataSource<FinancingMangoShow>();
  // selection = new SelectionModel<FinanceExample>(false, [this.dataSource.data[0]]);
  public financeForm: FormGroup;
  public isLoading: boolean = false;
  public disabled: boolean = false;
  @Input() public mode: string = 'new';
  @Input() public request: any = null;
  @Input() establishment: string;
  @Input() state: CommonDataDTO;
  @Input() financingCallDtoList: CalculatorResponseDTO;
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() isLoadingExternal = new EventEmitter<boolean>();
  @Input() changing: Subject<boolean>;

  constructor(private formBuilder: FormBuilder, private requestStore: RequestsSaveSendStore) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.establishment) {
      this.dataSource.data = [];
      this.financeForm?.reset();
      this.financingCallDtoList = null;
    }

    if (!changes?.financingCallDtoList?.isFirstChange() && changes?.financingCallDtoList?.currentValue) {
      this.financeForm.reset();
      const data: FinancingMangoShow = {
        discountPercentage: changes?.financingCallDtoList.currentValue.lstCalculatorFinancings[0]?.discountPercentage,
        discountWelcome: changes?.financingCallDtoList.currentValue.lstCalculatorFinancings[0]?.discountWelcome,
        netPurchaseAmount: changes?.financingCallDtoList.currentValue.lstCalculatorFinancings[0]?.netPurchaseAmount,
      };
      this.dataSource.data = [data];
      this.financeForm.controls.discountPercentage.setValue(data.discountPercentage);
      this.financeForm.controls.discountWelcome.setValue(data.discountWelcome);
      this.financeForm.controls.netPurchaseAmount.setValue(data.netPurchaseAmount);
      this.financeForm.controls.endContractDate.setValue(this.financingCallDtoList.strExpireDate);

      const terms = this.requestStore.listaFormulariosMg[REQUEST_DATA_MG].controls.term.value;
      let result = +data.netPurchaseAmount?.replace(',', '.') / terms;
      this.financeForm.controls.feeAmount.setValue(result.toFixed(2));
    }
  }

  ngOnInit(): void {
    this.financeForm = this.formBuilder.group({
      discountPercentage: [''],
      discountWelcome: [''],
      netPurchaseAmount: [''],
      feeAmount: [''],
      endContractDate: ['', Validators.required],
    });
    this.changing.subscribe((v) => {
      this.financingCallDtoList = null;
    });
    if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.financeForm, FINANCE); //NO SON LOS DATOS BASICOS DE CONTACTO, PERO ESTE COMPONENTE OCUPA LA POSICION 2 DEL ARRAY
    }

    this.financeForm.statusChanges.subscribe(() => {
      if (this.financeForm.valid) {
        this.changeContinueStatus.emit({ form: <FormGroup>this.financeForm, id: FINANCE });
      }
    });

    if (this.mode === REQUEST_MODE_VIEW) {
      this.disabled = this.state.id !== PENDIENTES_DE_DATOS;
    }
  }

  hasAnyFinancing(): boolean {
    if (this.financingCallDtoList !== null && this.financingCallDtoList !== undefined) {
      return this.financingCallDtoList.lstCalculatorFinancings.length > 0;
    }
    return false;
  }
}
